import React from 'react';
import PropTypes from 'prop-types';
import ButtonWithTooltip from './ButtonWithTooltip';

const PrimaryButton = (props) => {
  const {
    tooltipTitle, children, ...others
  } = props;
  return (
    <ButtonWithTooltip color="primary" tooltipTitle={tooltipTitle} {...others}>
      {children}
    </ButtonWithTooltip>
  );
};

PrimaryButton.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
  tooltipTitle: PropTypes.string.isRequired,
};

export default PrimaryButton;
